export const LINK_KEYS = [
	'campaign_report_link',
	'edr_rerating_report_link',
	'set_new_password_link',
	'support_team_link',
	'portal_url_link',
] as const;

export type LinkKey = (typeof LINK_KEYS)[number];

export const LINKS: { value: LinkKey; label: string }[] = LINK_KEYS.map((value) => ({
	value,
	label: 'mailSettings.link.' + value,
}));
